import Entity from './entity'
export default class Tag extends Entity<number>{
	 id:number;
     type:number;
	 name:string;
	 remark:string;
	 parentId:number
}

